export default [
  {
    path: '/workout-video-management',
    redirect: '/my-ads',
  },
  {
    path: '/workout-video-management/:id/edit',
    redirect: to => ({ path: `/my-ads/${to.params.id}/edit` }),
  },
  {
    path: '/workout-video-management/:id',
    redirect: to => ({ path: `/my-ads/${to.params.id}` }),
  },
  {
    path: '/workout-pending-videos',
    redirect: '/my-ads',
  },
  {
    path: '/workout-MostWatched-videos',
    redirect: '/my-ads',
  },
  {
    path: '/workout-AllVideo-videos',
    redirect: '/my-ads',
  },
  {
    path: '/settings/workout',
    redirect: '/settings/categories',
  },
  {
    path: '/settings/predesignworkout',
    redirect: '/settings/categories',
  },
  {
    path: '/dashboard',
    name: 'my-poda-dashboard',
    component: () => import('@/features/dashboard/pages/dashboard.vue'),
  },
  {
    path: '/dashboard-overall-details',
    name: 'dashboard-overall-details',
    component: () => import('@/features/dashboard/pages/DashboardOverallDetails.vue'),
    meta: {
      HideHomeIcon: true,
      contentClass: 'ecommerce-application',
      navActiveLink: 'my-ads',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Overall Details',
          active: true,
        },
      ],
    },
  },
  {
    path: '/uploaded-ads',
    name: 'uploaded-ads',
    component: () => import('@/features/ads/pages/UploadedAds.vue'),
    meta: {
      HideHomeIcon: true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Uploaded Ads', active: true },
      ],
    },
  },
  {
    path: '/create-ad',
    name: 'create-ad',
    component: () => import('@/features/ads/pages/CreateAd.vue'),
    meta: {
      HideHomeIcon: true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Create Ad', active: true },
      ],
    },
  },
  {
    path: '/brands',
    name: 'brands',
    component: () => import('@/features/brands/pages/Brands.vue'),
    meta: {
      HideHomeIcon: true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Brands', active: true },
      ],
    },
  },
  {
    path: '/my-ads',
    name: 'my-ads',
    component: () => import('@/features/ads/pages/videoManagement/MyAds.vue'),
    meta: {
      HideHomeIcon: true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
          class: 'breadcrumb-slash',
        },
        {
          text: 'My Ads',
          active: true,
        },
      ],
    },
  },
  {
    path: '/my-ads/:id/edit',
    name: 'edit-ad',
    component: () => import('@/features/ads/pages/CreateAd.vue'),
    meta: {
      HideHomeIcon: true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'My Ads', to: '/my-ads' },
        { text: 'Edit Ad', active: true },
      ],
    },
  },
  {
    path: '/my-ads/:id',
    name: 'my-ads-detail',
    component: () => import('@/features/ads/pages/videoManagement/MyAdsDetail.vue'),
    meta: {
      HideHomeIcon: true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'My Ads',
          to: '/my-ads',
        },
        {
          text: 'Ad details',
          active: true,
        },
      ],
    },
  },
  {
    path: '/settings/allvideos',
    name: 'setting-AllVideo',
    component: () => import('@/features/settings/pages/Videos.vue'),
    meta: {
      HideHomeIcon: true,
      pageTitle: 'All Hide Videos',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'My Profile',
          to: '/admin/profile',

        },
        {
          text: 'Setting',
          to: '/admin/settings',
        },
        {
          text: 'Hide Videos',
          active: true,
        },
      ],
    },
  },
  {
    path: '/settings/audio',
    name: 'setting-audio',
    component: () => import('@/features/settings/pages/audio/Audio.vue'),
    meta: {
      HideHomeIcon: true,
      pageTitle: 'Audio',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'My Profile',
          to: '/admin/profile',

        },
        {
          text: 'Setting',
          to: '/admin/settings',
        },
        {
          text: 'Audio',
          active: true,
        },
      ],
    },
  },
  {
    path: '/settings/categories',
    name: 'setting-categories',
    component: () => import('@/features/settings/pages/Categories.vue'),
    meta: {
      HideHomeIcon: true,
      pageTitle: 'Categories',

      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'My Profile',
          to: '/admin/profile',

        },
        {
          text: 'Setting',
          to: '/admin/settings',
        },
        {
          text: 'categories',
          active: true,
        },
      ],
    },
  },
  {
    path: '/music',
    name: 'setting-music',
    component: () => import('@/features/settings/pages/audio/Music.vue'),
    meta: {
      HideHomeIcon: true,
      pageTitle: 'Music',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'My Profile',
          to: '/profile',

        },
        {
          text: 'Music',
          active: true,
        },
      ],
    },
  },
  {
    path: '/add-music',
    name: 'setting-add-audio',
    component: () => import('@/features/settings/pages/audio/AddMusic.vue'),
    meta: {
      HideHomeIcon: true,
      pageTitle: 'Music',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'My Profile',
          to: '/profile',

        },
        {
          text: 'Add-Music',
          active: true,
        },
      ],
    },
  },
  {
    path: '/edit-music/:id',
    name: 'edit-music',
    component: () => import('@/features/settings/pages/audio/AddMusic.vue'),
    meta: {
      HideHomeIcon: true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Music',
          to: '/music',
        },
        {
          text: 'Edit Music',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports',
    name: 'reports',
    component: () => import('@/features/reports/pages/Reports.vue'),
    meta: {
      HideHomeIcon: true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Reports',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports/likes',
    name: 'reports-likes',
    component: () => import('@/features/reports/pages/ReportsMetricDetail.vue'),
    meta: {
      metricKey: 'likes',
      HideHomeIcon: true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Reports', to: '/reports' },
        { text: 'Likes', active: true },
      ],
    },
  },
  {
    path: '/reports/dislikes',
    name: 'reports-dislikes',
    component: () => import('@/features/reports/pages/ReportsMetricDetail.vue'),
    meta: {
      metricKey: 'dislikes',
      HideHomeIcon: true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Reports', to: '/reports' },
        { text: 'Dislikes', active: true },
      ],
    },
  },
  {
    path: '/reports/followers',
    name: 'reports-followers',
    component: () => import('@/features/reports/pages/ReportsMetricDetail.vue'),
    meta: {
      metricKey: 'followers',
      HideHomeIcon: true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Reports', to: '/reports' },
        { text: 'Followers', active: true },
      ],
    },
  },
  {
    path: '/reports/clicks',
    name: 'reports-clicks',
    component: () => import('@/features/reports/pages/ReportsMetricDetail.vue'),
    meta: {
      metricKey: 'clicks',
      HideHomeIcon: true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Reports', to: '/reports' },
        { text: 'Clicks', active: true },
      ],
    },
  },
  {
    path: '/reports/saved',
    name: 'reports-saved',
    component: () => import('@/features/reports/pages/ReportsMetricDetail.vue'),
    meta: {
      metricKey: 'saved',
      HideHomeIcon: true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Reports', to: '/reports' },
        { text: 'Saved', active: true },
      ],
    },
  },
  {
    path: '/reports/share',
    name: 'reports-share',
    component: () => import('@/features/reports/pages/ReportsMetricDetail.vue'),
    meta: {
      metricKey: 'share',
      HideHomeIcon: true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Reports', to: '/reports' },
        { text: 'Share', active: true },
      ],
    },
  },
  {
    path: '/reports/reports',
    name: 'reports-reports',
    component: () => import('@/features/reports/pages/ReportsMetricDetail.vue'),
    meta: {
      metricKey: 'reports',
      HideHomeIcon: true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Reports', to: '/reports' },
        { text: 'Reports', active: true },
      ],
    },
  },
  {
    path: '/notification',
    name: 'notification',
    component: () => import('@/features/notifications/pages/Notification.vue'),
    meta: {
      HideHomeIcon: true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'My Profile',
          to: '/Admin/profile',
        },
        {
          text: 'Notification',
          active: true,
        },
      ],
    },
  },
  {
    path: '/Plan-Renewal',
    name: 'Plan Renewal',
    component: () => import('@/features/billing/pages/PlanRenewable.vue'),
    meta: {
      HideHomeIcon: true,
      pageTitle: 'Billing',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Billing',
          active: true,
        },
      ],
    },
  },
  {
    path: '/Plan-Renewal/details',
    name: 'billing-details',
    component: () => import('@/features/billing/pages/BillingDetails.vue'),
    meta: {
      HideHomeIcon: true,
      pageTitle: 'Billing Details',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Billing',
          to: '/Plan-Renewal',
        },
        {
          text: 'Billing Details',
          active: true,
        },
      ],
    },
  },
  // {
  //   path: '/admin',
  //   name: 'admin',
  //   component: () => import('@/features/profile/pages/AdminProfile.vue'),
  //   meta: {
  //     HideHomeIcon:true,
  //     pageTitle: 'Admin Profile',
  //     breadcrumb: [
  //       {
  //         text: 'Home',
  //         to:'/dashboard'
  //       },
  //       {
  //         text: 'Profile',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/features/profile/pages/AdminProfile.vue'),
    meta: {
      HideHomeIcon: true,
      pageTitle: 'Admin Profile',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Profile',
          active: true,
        },
      ],
    },
  },
  {
    path: '/cms',
    name: 'cms',
    component: () => import('@/features/cms/pages/cmsmain.vue'),
    meta: {
      HideHomeIcon: true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'CMS',
          active: true,
        },
      ],
    },
  },
  {
    path: '/cms',
    name: 'cms',
    component: () => import('@/features/cms/pages/cmsmain.vue'),
    meta: {
      HideHomeIcon: true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'CMS',
          active: true,
        },
      ],
    },
  },
  {
    path: '/cms/addcms',
    name: 'add-cms',
    component: () => import('@/features/cms/pages/AddCms.vue'),
    meta: {
      HideHomeIcon: true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'CMS',
          to: '/cms',
        },
        {
          text: 'Add CMS',
          active: true,
        },
      ],
    },
  },
  {
    path: '/cms/editcms/:id',
    name: 'edit-cms',
    component: () => import('@/features/cms/pages/AddCms.vue'),
    meta: {
      HideHomeIcon: true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'CMS',
          to: '/cms',
        },
        {
          text: 'Edit CMS',
          active: true,
        },
      ],
    },
  },
  // {
  //   path: '/apps/e-commerce/:slug',
  //   name: 'apps-e-commerce-product-details',
  //   component: () => import('@/views/apps/e-commerce/e-commerce-product-details/ECommerceProductDetails.vue'),
  //   meta: {
  //     pageTitle: 'Product Details',
  //     contentClass: 'ecommerce-application',
  //     breadcrumb: [
  //       {
  //         text: 'ECommerce',
  //       },
  //       {
  //         text: 'Shop',
  //         active: true,
  //       },
  //       {
  //         text: 'Product Details',
  //         active: true,
  //       },
  //     ],
  //   },
  // },

]
